'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$CredentialName$$anon$50(name$5, outer) {
  this.c4P = null;
  this.c4P = name$5;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$CredentialName$$anon$50 as $c_Lpresto_types$CredentialName$$anon$50 };
$p = $c_Lpresto_types$CredentialName$$anon$50.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$CredentialName$$anon$50;
/** @constructor */
function $h_Lpresto_types$CredentialName$$anon$50() {
}
export { $h_Lpresto_types$CredentialName$$anon$50 as $h_Lpresto_types$CredentialName$$anon$50 };
$h_Lpresto_types$CredentialName$$anon$50.prototype = $p;
$p.nC = (function(seq) {
  return seq.b1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((it) => it.Eo.gY(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((c) => {
    var this$2 = c.fy;
    var this$4 = this$2.toLowerCase();
    var this$3 = this.c4P;
    var s = this$3.toLowerCase();
    return ((this$4.indexOf(s) | 0) !== (-1));
  }))))));
});
var $d_Lpresto_types$CredentialName$$anon$50 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$CredentialName$$anon$50, "presto.types$CredentialName$$anon$50", ({
  YY: 1,
  bM: 1
}));
export { $d_Lpresto_types$CredentialName$$anon$50 as $d_Lpresto_types$CredentialName$$anon$50 };
//# sourceMappingURL=presto.types$-Credential-Name$$anon$50.js.map
